document.addEventListener("DOMContentLoaded", function() {
    const wkPodsProduct = document.querySelector('.wk-pods-product');
    const selects = document.querySelectorAll('.quantity-select');
    const priceItems = document.querySelectorAll('.pod-wrap');
    const moneyUpdate = document.querySelectorAll('.money_update');
    const priceContainer = document.querySelectorAll('.price-item--regular');
    const addToCartBtn = document.querySelector('.prod--addToCartBtn');
    const mainQuantitySelect = document.querySelector('.main-quantity-select');

    const isOneOffProduct = wkPodsProduct?.classList.contains('wk-pods-product--one-off');

    const buyTypeInputs = document.querySelectorAll('input[name="buy_type"]');
    const purchaseTypeRoot = document.querySelector('.oneoff-steps-product');

    function isSubscriptionPurchase() {
      if (buyTypeInputs.length) {
        const checked = Array.from(buyTypeInputs).find(input => input.checked);
        return checked ? checked.value === 'subscription' : true;
      }
      return !isOneOffProduct;
    }

    function syncPurchaseTypeState() {
      const subscriptionSelected = isSubscriptionPurchase();

      document.querySelectorAll('.subscription_box').forEach(el => {
        el.classList.toggle('active-purchase', subscriptionSelected);
      });
      document.querySelectorAll('.oneoff_box').forEach(el => {
        el.classList.toggle('active-purchase', !subscriptionSelected);
      });

      if (purchaseTypeRoot) {
        purchaseTypeRoot.classList.toggle('purchase-type--subscription-active', subscriptionSelected);
        purchaseTypeRoot.classList.toggle('purchase-type--oneoff-active', !subscriptionSelected);
      }
    }

    buyTypeInputs.forEach(input => {
      input.addEventListener('change', () => {
        syncPurchaseTypeState();
        updatePrice();
      });
    });

    document.querySelectorAll('.purchase-type-card').forEach(card => {
      card.addEventListener('click', event => {
        if (event.target.closest('select, option, button, a, modal-opener, label')) return;
        const input = card.querySelector('input[type="radio"]');
        if (input && !input.checked) input.click();
      });
    });

    syncPurchaseTypeState();

    function syncPurchaseSummaryFrequency() {
      const select = document.querySelector('.pods_select_box');
      const label = document.querySelector('.purchase-summary__frequency');
      if (!select || !label || !select.selectedOptions.length) return;
      label.textContent = '(' + select.selectedOptions[0].textContent.trim().toLowerCase() + ')';
    }

    document.addEventListener('change', event => {
      if (event.target.matches('.pods_select_box')) {
        syncPurchaseSummaryFrequency();
      }
    });

    syncPurchaseSummaryFrequency();

    const sizeDescription = document.querySelector('.step_2_size_description');

    function updateAmountDependentText(mainQuantity) {
      if (!sizeDescription) return;
      const template = sizeDescription.getAttribute('data-template');
      if (!template) return;
      sizeDescription.textContent = template
        .replace('[boxes]', mainQuantity / 10)
        .replace('[pods]', mainQuantity);
    }

    let maxQuantity = 0;
    let volumeDiscountPercent = 0;
    if (wkPodsProduct) {
      const dataTotalQuantity = wkPodsProduct.dataset.totalQuantity;
      if (dataTotalQuantity) {
        maxQuantity = parseInt(dataTotalQuantity, 10) || 0;
      }
      volumeDiscountPercent = parseFloat(wkPodsProduct.dataset.initialVolumeDiscountPercent) || 0;
    }

    function getTotalSelected() {
      let total = 0;
      selects.forEach(select => {
        total += parseInt(select.value, 10) || 0;
      });
      return total;
    }

    function getSelectedVolumeDiscountPercent(select) {
      const selectedOption = select.selectedOptions && select.selectedOptions[0];
      const savePercentageEl = selectedOption ? selectedOption.querySelector('.save_percentage') : null;
      if (!savePercentageEl) return 0;
      const match = savePercentageEl.textContent.match(/(\d+(\.\d+)?)/);
      return match ? parseFloat(match[1]) : 0;
    }

    if (mainQuantitySelect) {
      mainQuantitySelect.addEventListener('change', function() {
        const mainQuantity = parseInt(this.value, 10) || 0;
        if (mainQuantity < getTotalSelected()) {
          selects.forEach(select => { select.selectedIndex = 0; });
        }
        maxQuantity = mainQuantity;
        volumeDiscountPercent = getSelectedVolumeDiscountPercent(this);
        updateAmountDependentText(mainQuantity);
        updateAll();
      });
    }

    // Custom-styled trigger + panel for the amount/quantity select above -
    // proxies clicks to the real (visually-hidden) <select> so the existing
    // change-driven maxQuantity logic keeps working untouched.
    document.querySelectorAll('[data-amount-dropdown]').forEach(function (dropdown) {
      var targetId = dropdown.dataset.target;
      var realSelect = targetId ? document.getElementById(targetId) : null;
      var trigger = dropdown.querySelector('.amount-dropdown__trigger');
      var panel = dropdown.querySelector('.amount-dropdown__panel');
      var label = dropdown.querySelector('[data-amount-label]');
      var triggerBadge = trigger.querySelector('[data-amount-trigger-badge]');
      if (!realSelect || !trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        panel.classList.toggle('hidden', expanded);
      });

      document.addEventListener('click', function (event) {
        if (!dropdown.contains(event.target)) {
          trigger.setAttribute('aria-expanded', 'false');
          panel.classList.add('hidden');
        }
      });

      dropdown.querySelectorAll('.amount-dropdown__option').forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.stopPropagation();
          dropdown.querySelectorAll('.amount-dropdown__option').forEach(function (opt) {
            opt.classList.remove('is-selected');
          });
          option.classList.add('is-selected');
          if (label) {
            var text = Array.from(option.childNodes)
              .filter(function (node) { return !node.classList || !node.classList.contains('amount-dropdown__badge'); })
              .map(function (node) { return node.textContent; })
              .join('')
              .trim();
            label.textContent = text;
          }
          if (triggerBadge) {
            var optionBadge = option.querySelector('.amount-dropdown__badge');
            if (optionBadge) {
              triggerBadge.textContent = optionBadge.textContent;
              triggerBadge.classList.remove('hidden');
            } else {
              triggerBadge.textContent = '';
              triggerBadge.classList.add('hidden');
            }
          }
          realSelect.value = option.dataset.amountValue;
          realSelect.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.setAttribute('aria-expanded', 'false');
          panel.classList.add('hidden');
        });
      });
    });

    function parsePrice(value) {
      if (!value) return 0;
      return parseFloat(value.replace(',', '.')) || 0;
    }

    function formatPrice(value) {
      return `€${value.toFixed(2)}`.replace('.', ',');
    }

    // Each selected pod flavor is its own cart line, sold as a real Shopify
    // variant that covers `data-pod-price-multiplier` pods (e.g. a 10-pod
    // box) - `data-pod-price` is only that box price divided down to a
    // per-pod display figure. Shopify's selling-plan discount rounds to the
    // nearest cent on the real per-box unit price, then multiplies by the
    // number of boxes - not on the per-pod price, and not once on the
    // combined total across flavors. E.g. a €5.90 box: round(5.90 x 0.95) =
    // 5.61/box x 4 boxes = 22.44, not round(23.60 total x 0.95) = 22.42.
    function roundToCent(value) {
      return Math.round(value * 100) / 100;
    }

    function updatePrice() {
      const configuredDiscountPercent = parseInt(
        document.querySelector('.purchase-type-list')?.getAttribute('data-subscription-discount-percent'),
        10
      ) || 0;
      // The Step 1 amount tier discount (e.g. -5% for 18 boxes) and the
      // subscription discount are multiplicative, not additive - i.e. base
      // price x 0.95 (subscription) x 0.85 (15% volume), not base price x
      // (1 - 0.05 - 0.15). Matches the same rule already applied to bulk
      // bean pricing (see custom.bulk_volume_discount_percent).
      const oneoffDiscountPercent = volumeDiscountPercent;

      let totalSelected = 0;
      let totalOnetimePrice = 0;
      let discountedSubPrice = 0;

      priceItems.forEach(pod => {
        const select = pod.querySelector('.quantity-select');
        const basePricePerPod = parsePrice(pod.getAttribute('data-pod-price'));
        const priceMultiplier = parseInt(pod.getAttribute('data-pod-price-multiplier'), 10) || 1;
        const quantity = parseInt(select.value, 10) || 0;

        totalSelected += quantity;
        totalOnetimePrice += quantity * basePricePerPod;

        const unitBoxes = quantity / priceMultiplier;
        const basePricePerUnit = basePricePerPod * priceMultiplier;
        const onetimePerUnit = roundToCent(basePricePerUnit * (1 - oneoffDiscountPercent / 100));
        const subPerUnit = roundToCent(onetimePerUnit * (1 - configuredDiscountPercent / 100));
        discountedSubPrice += unitBoxes * subPerUnit;
      });

      const discountedOnetimePrice = totalOnetimePrice * (1 - oneoffDiscountPercent / 100);

      // Only used for the "-X%" badges/labels - the actual combined percent
      // the two discounts amount to together, not their sum.
      const subDiscountPercent = Math.round(
        (1 - (1 - oneoffDiscountPercent / 100) * (1 - configuredDiscountPercent / 100)) * 100
      );

      const subscriptionSelected = isSubscriptionPurchase();
      const displayTotal = subscriptionSelected ? discountedSubPrice : discountedOnetimePrice;

      // Each purchase-type card (and the bottom summary) shows its own price
      // independent of which option is currently selected — the subscribe
      // card always shows the sub price, the one-time card always shows the
      // one-time price. Only price displays outside both contexts (e.g. the
      // simple one-off-only layout) fall back to the currently selected total.
      moneyUpdate.forEach(el => {
        if (el.closest('.purchase-type-card--subscription, .subscription_box, .purchase-summary--subscription')) {
          el.textContent = formatPrice(discountedSubPrice);
        } else if (el.closest('.purchase-type-card--oneoff, .oneoff_box, .purchase-summary--oneoff')) {
          el.textContent = formatPrice(discountedOnetimePrice);
        } else {
          el.textContent = formatPrice(displayTotal);
        }
      });

      // The subscribe card's strikethrough comparison describes the
      // subscription price itself, not the currently active choice — it
      // should stay visible whenever a real combined discount exists,
      // regardless of which purchase option is selected.
      const hasSubscriptionDiscount = totalOnetimePrice > 0 && subDiscountPercent > 0;

      document.querySelectorAll('.pods-price-compare').forEach(el => {
        if (hasSubscriptionDiscount) {
          el.textContent = formatPrice(totalOnetimePrice);
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });

      document.querySelectorAll('.pods-discount-badge').forEach(el => {
        if (hasSubscriptionDiscount) {
          el.textContent = `-${subDiscountPercent}%`;
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });

      const hasOneoffDiscount = totalOnetimePrice > 0 && oneoffDiscountPercent > 0;

      document.querySelectorAll('.pods-oneoff-price-compare').forEach(el => {
        if (hasOneoffDiscount) {
          el.textContent = formatPrice(totalOnetimePrice);
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });

      document.querySelectorAll('.pods-oneoff-discount-badge').forEach(el => {
        if (hasOneoffDiscount) {
          el.textContent = `-${oneoffDiscountPercent}%`;
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });


      const badgeText = document.querySelector('.pods-selected-badge__text');
      if (badgeText) {
        const template = badgeText.getAttribute('data-template') || '[selected]/[total] selected';
        badgeText.textContent = template
          .replace('[selected]', totalSelected)
          .replace('[total]', maxQuantity);
      }

      // The total across all pods must exactly match the amount chosen in
      // Step 1 (e.g. 40 pods for "4 box") - not just be non-zero - otherwise
      // an incomplete selection (e.g. 30/40) could still be added to cart.
      if (maxQuantity > 0 && totalSelected === maxQuantity) {
        priceContainer.forEach(el => el.classList.remove('disabled-price'));
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('disabled');
        }
      } else {
        priceContainer.forEach(el => el.classList.add('disabled-price'));
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('disabled');
        }
      }
    }

    function updateOptions() {
      // The combined total across all pods is capped at the amount chosen in
      // Step 1: each select's own options are limited by what's left of that
      // budget once every other pod's current selection is accounted for.
      const totalSelected = getTotalSelected();
      selects.forEach(select => {
        const currentValue = parseInt(select.value, 10) || 0;
        const otherPodsSelected = totalSelected - currentValue;
        const remaining = maxQuantity > 0 ? maxQuantity - otherPodsSelected : Infinity;

        let selectionStillValid = false;
        Array.from(select.options).forEach(option => {
          const value = parseInt(option.value, 10) || 0;
          const disabled = value > remaining;
          option.disabled = disabled;
          option.style.display = disabled ? 'none' : 'block';
          if (!disabled && option.selected) selectionStillValid = true;
        });

        if (!selectionStillValid) {
          const options = Array.from(select.options);
          for (let i = options.length - 1; i >= 0; i--) {
            if (!options[i].disabled) {
              select.selectedIndex = i;
              break;
            }
          }
        }
      });
    }

    function updateSteppers() {
      selects.forEach(select => {
        const wrap = select.closest('.pod-quantity-wrap');
        if (!wrap) return;
        const stepper = wrap.querySelector('.pod-quantity-stepper');
        const valueEl = wrap.querySelector('.pod-quantity-stepper__value');
        const minusBtn = wrap.querySelector('.pod-quantity-stepper__button--minus');
        const plusBtn = wrap.querySelector('.pod-quantity-stepper__button--plus');
        const options = Array.from(select.options);
        const currentIndex = select.selectedIndex;
        const currentValue = parseInt(select.value, 10) || 0;

        if (valueEl) valueEl.textContent = select.value;
        if (stepper) stepper.classList.toggle('pod-quantity-stepper--active', currentValue > 0);
        if (minusBtn) minusBtn.disabled = currentIndex <= 0;
        if (plusBtn) {
          const hasNextEnabled = options.slice(currentIndex + 1).some(option => !option.disabled);
          plusBtn.disabled = !hasNextEnabled;
        }
      });
    }

    function updateAll() {
      updateOptions();
      updatePrice();
      updateSteppers();
    }

    document.querySelectorAll('.pod-quantity-stepper__button').forEach(button => {
      button.addEventListener('click', () => {
        const wrap = button.closest('.pod-quantity-wrap');
        const select = wrap && wrap.querySelector('.quantity-select');
        if (!select) return;

        const direction = button.classList.contains('pod-quantity-stepper__button--plus') ? 1 : -1;
        let nextIndex = select.selectedIndex + direction;

        while (nextIndex >= 0 && nextIndex < select.options.length && select.options[nextIndex].disabled) {
          nextIndex += direction;
        }

        if (nextIndex < 0 || nextIndex >= select.options.length) return;

        select.selectedIndex = nextIndex;
        select.dispatchEvent(new Event('change'));
      });
    });

    selects.forEach(select => {
      select.addEventListener('change', updateAll);
    });

    updateAll();

    $('.wk-pods-product .prod--addToCartBtn').on('click', function (e) {
        e.preventDefault();
    
        var form_data = new FormData();
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var random_num = Math.floor(Math.random() * 10000) + 1;
    
        $('.pod-wrap').each(function (i, v) {
            var variantId = $(v).data('variant-id');
            if (!variantId) {
                console.error('Variant ID is missing or invalid for pod:', i);
                return;
            }
        
            var podsQuantity = parseInt($(v).find('.quantity-select').val(), 10) || 0;
            var podPriceMultiplier = parseInt($(v).attr('data-pod-price-multiplier'), 10) || 1;
            var quantity = podsQuantity / podPriceMultiplier;
            var name = "items[" + i + "]";

            form_data.append(name + "[id]", variantId);
            form_data.append(name + "[quantity]", quantity);
            form_data.append(name + "[properties][_collection_title]", "collection_pods");
            form_data.append(name + "[properties][cart-order-id]", `${random_num}`);
            if(isSubscriptionPurchase()){
              const frequencySelect = document.querySelector('.pods_select_box');
              form_data.append(name + "[properties][frequency]", `${$(frequencySelect).val()}`);
              if (frequencySelect && frequencySelect.selectedOptions.length) {
                form_data.append(name + "[properties][frequency_label]", frequencySelect.selectedOptions[0].textContent.trim());
              }

              const selectedIndex = frequencySelect ? frequencySelect.selectedIndex : -1;
              let planIds = [];
              try {
                planIds = JSON.parse($(v).attr('data-pod-plan-ids') || '[]');
              } catch (e) {
                planIds = [];
              }
              if (selectedIndex >= 0 && planIds[selectedIndex]) {
                form_data.append(name + "[selling_plan]", planIds[selectedIndex]);
              }
            }

        });
    
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart) {
            if (typeof cart.getSectionsToRender === 'function') {
                form_data.append('sections', cart.getSectionsToRender().map((section) => section.id));
            }
            form_data.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
        }

        config.body = form_data;

        fetch('/cart/add.js', config)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((response) => {
                if (cart && typeof cart.renderContents === 'function') {
                    cart.renderContents(response);
                    if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                }

                $(".product-option").each(function (i, val) {
                    var ss = $(val).find('div').text();
                    if (ss.indexOf("_collection_title:") > -1) {
                        $(val).parents('.cart_wrapper_flex').find('.quantity__button').addClass('disabled');
                        $(val).parents('.cart_wrapper_flex').find('.quantity__button').attr('disabled', "disabled");
                        $(val).parents('.cart_wrapper_flex').find('.quantity__button.minus').addClass('disabled');
                    }
                });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });


    const infoToggles = document.querySelectorAll('.more-info');

    infoToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        const outerWrap = toggle.closest('.pod-wrap');
        const description = outerWrap.querySelector('.more-info-description');
        const inner = description.querySelector('.more-info-description-inner');
        const title = toggle.querySelector('.more-info-title');
        const titleHide = toggle.querySelector('.more-info-title-hide');

        if (!description.style.height || description.style.height === '0px') {
          const contentHeight = inner.scrollHeight + 'px';

          description.style.height = contentHeight;
          toggle.setAttribute('aria-expanded', 'true');
          if (title) title.classList.add('hidden');
          if (titleHide) titleHide.classList.remove('hidden');

          description.addEventListener('transitionend', function endTransitionOpen() {
            description.removeEventListener('transitionend', endTransitionOpen);
            description.style.height = 'auto';
          }, { once: true });

        } else {
          description.style.height = description.scrollHeight + 'px';

          requestAnimationFrame(() => {
            description.style.height = '0';
          });

          toggle.setAttribute('aria-expanded', 'false');
          if (title) title.classList.remove('hidden');
          if (titleHide) titleHide.classList.add('hidden');
        }
      });
    });
  });